// deprecated

//LIBRARIES
import React, { Component, Fragment } from 'react';
import { browserHistory } from 'react-router';
import { reduxForm, Field, formValueSelector, change } from 'redux-form';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { TextField, SelectField, Checkbox } from 'redux-form-material-ui';
import MenuItem from 'material-ui/MenuItem';
import FlatButton from 'material-ui/FlatButton';
import camelCase from 'lodash/camelCase';
import Auth from 'j-toker';

//COMPONENTS
import RenderDropzoneMultiFileInput from 'components/shared/RenderDropzoneMultiFileInput';
import TenantResidentVerbiageHelper from 'components/shared/TenantResidentVerbiageHelper';
import { requestDropdown } from 'components/shared/maintenanceDropdownValues';
import SearchableSelectRedux from 'components/shared/SearchableSelectRedux';
import RecurringFields from 'components/shared/RecurringFields';
import TenantMaintenanceNotes from 'components/tenant_app/components/TenantMaintenanceNotes';
import Header from 'components/shared/Header';
import { RenderIfToggleOn } from 'components/shared/ToggleRenderer';
import TicketAssignmentForm from './TicketAssignmentForm';
import NotesSection from './Notes/NotesSection';

//HELPERS
import { getSuiteRooms } from 'helpers/SelectOptions';
import * as formatter from 'helpers/Formatter';
import * as validator from 'helpers/Validator';
import { deepDiver } from 'helpers/utilities';
import { featureEnabled } from 'helpers/ToggleBot';
import { colors } from 'helpers/ColorHelper';
import Autosuggest from 'helpers/reduxFormMaterialUiNext/Autosuggest';
import { AccentColor } from 'helpers/AccentColorHelper';
import { hostIsBoardwalk, hostIsCapreit } from 'helpers/CurrentWindowLocation';
import DatePickerAccessible from 'helpers/reduxFormMaterialUiNext/DatePickerAccessible';
import { getTranslatedString } from 'helpers/i18n';

//ACTIONS
import { getListOfMaintenanceStaff, getAssets } from 'actions/maintenanceActions';
import { getProperties, getUnits, showUnits } from 'actions/landlordPropertiesActions';
import { remindVendor } from 'actions/maintenanceTicketActions';

let EditMaintenanceTicketForm = class EditMaintenanceTicketForm extends Component {
  openTenant = (tenantID) => {
    browserHistory.push(`/companies/tenants?tenantId=${tenantID}`);
  };

  readOnly = () => {
    if (hostIsBoardwalk() === true) {
      return true;
    }

    if (hostIsCapreit() && Auth.user.type.toLowerCase() === 'maintenance') {
      return true;
    }

    return false;
  };

  getPropertyType = () => {
    const { selectedProperty, properties } = this.props;
    if (!selectedProperty) return null;

    const propertyHash = properties.find((property) => property.value === selectedProperty.value);
    return propertyHash && propertyHash.property_type;
  };

  getMaintenanceTicketCategories = () => {
    const { selectedProperty, selectedUnit, maintenanceCategories } = this.props;
    if (selectedProperty && selectedUnit) {
      return maintenanceCategories.filter((category) =>
        ['suite', 'all_locations'].includes(category.location)
      );
    }

    return maintenanceCategories.filter((category) =>
      ['common_area', 'all_locations'].includes(category.location)
    );
  };

  getMaintenanceStatuses = () => {
    let statuses = [
      {
        value: 'new',
        label: 'landlordPortal.editMaintenanceTicketForm.new',
        disabled: false,
      },
      {
        value: 'Reviewed',
        label: 'landlordPortal.editMaintenanceTicketForm.reviewed',
        disabled: false,
      },
      {
        value: 'Scheduled',
        label: 'landlordPortal.editMaintenanceTicketForm.scheduled',
        disabled: featureEnabled('ui.create_service_request.disable_working_statuses'),
      },
      {
        value: 'assigned',
        label: 'landlordPortal.editMaintenanceTicketForm.assigned',
        disabled: false,
        hide: !featureEnabled('ui.create_service_request.assign_status'),
      },
      {
        value: 'Fixing',
        label: 'landlordPortal.editMaintenanceTicketForm.fixing',
        disabled: featureEnabled('ui.create_service_request.disable_working_statuses'),
      },
      {
        value: 'Fixed',
        label: 'landlordPortal.editMaintenanceTicketForm.fixed',
        disabled: false,
      },
      {
        value: 'Parts Needed',
        label: 'landlordPortal.editMaintenanceTicketForm.partsNeeded',
        disabled: featureEnabled('ui.create_service_request.disable_working_statuses'),
      },
      {
        value: 'Contractor Needed',
        label: 'landlordPortal.editMaintenanceTicketForm.contractorNeeded',
        disabled: featureEnabled('ui.create_service_request.disable_working_statuses'),
      },
      {
        value: 'Contact Tenant',
        label: 'landlordPortal.editMaintenanceTicketForm.contactTenant',
        disabled: false,
      },
      {
        value: 'Closed',
        label: 'landlordPortal.editMaintenanceTicketForm.closed',
        disabled: false,
      },
      {
        value: 'Acknowledged',
        label: 'landlordPortal.editMaintenanceTicketForm.acknowledged',
        disabled: true,
      },
      {
        value: 'Deferred',
        label: 'landlordPortal.editMaintenanceTicketForm.deferred',
        disabled: true,
      },
      {
        value: 'vendor_ongoing',
        label: 'landlordPortal.editMaintenanceTicketForm.vendorOngoing',
        disabled: true,
        hide: !featureEnabled('maintenance.vendor_statuses_and_notifications'),
      },
      {
        value: 'vendor_other',
        label: 'landlordPortal.editMaintenanceTicketForm.vendorOther',
        disabled: true,
        hide: !featureEnabled('maintenance.vendor_statuses_and_notifications'),
      },
      {
        value: 'vendor_cancelled',
        label: 'landlordPortal.editMaintenanceTicketForm.vendorCancelled',
        disabled: true,
        hide: !featureEnabled('maintenance.vendor_statuses_and_notifications'),
      },
      {
        value: 'cancelled',
        label: 'landlordPortal.editMaintenanceTicketForm.cancelled',
        disabled: true,
      },
      {
        value: 'cancelled_dup',
        label: 'landlordPortal.editMaintenanceTicketForm.cancelledDup',
        disabled: true,
      },
      {
        value: 'cancelled_no_res',
        label: 'landlordPortal.editMaintenanceTicketForm.cancelledNoResponse',
        disabled: true,
      },
    ];

    return statuses.filter((status) => !status.hide);
  };

  handleAssigneeChange = (_event, newValue, previousValue) => {
    if (!featureEnabled('ui.create_service_request.assign_status')) return;
    const noAssignee = !newValue || newValue.value === null;
    const hasAsignee = !noAssignee;

    if (noAssignee && previousValue && this.props.status === 'assigned') {
      // If remove assignee and status is assigned, set status to reviewed
      this.props.changeFormValue(this.props.formName, 'status', 'Reviewed');
    } else if (hasAsignee && newValue !== previousValue) {
      // If adding assigninee or changing assignee, set status to assigned
      this.props.changeFormValue(this.props.formName, 'status', 'assigned');
    }
  };

  remindVendor = () => {
    this.props.remindVendor(this.props.ticketId);
  };

  canRemindVendor = () => {
    if (!this.props.assignedTo || this.props.assignedTo.type !== 'Vendor') {
      return false;
    }

    return ![
      'cancelled_dup',
      'cancelled',
      'cancelled_no_res',
      'Closed',
      'vendor_cancelled',
      'Fixed',
    ].includes(this.props.ticketStatus);
  };

  render() {
    const FILE_FIELD_NAME = 'files';
    const readOnly = this.readOnly();
    const style = {
      receipt_header: {
        margin: '10px 0 10px 0',
        backgroundColor: '#f1f1f1',
        padding: '5px 10px',
        fontSize: '14px',
        fontWeight: '800',
        borderRadius: '3px',
      },
    };

    return (
      <form autoComplete="off">
        <div className="row" style={{ marginTop: '-10px' }}>
          <div className="row" style={style.receipt_header}>
            <div className="col-xs-12">
              <p style={{ margin: '0', textAlign: 'center' }}>
                {getTranslatedString('landlordPortal.editMaintenanceTicketForm.locationUpcase')}
              </p>
            </div>
          </div>
          <div className="row" style={{ marginBottom: '20px', padding: '0 15px' }}>
            <TicketAssignmentForm formName={this.props.form} readOnly={readOnly} />
            {this._renderTenantDetailsIndustrial()}
            {this._renderTenantDetails(readOnly)}
          </div>

          {this.props.showRecurrance && (
            <div className="row">
              <div className="row" style={style.receipt_header}>
                <div className="col-xs-12">
                  <p style={{ margin: '0', textAlign: 'center' }}>
                    {getTranslatedString(
                      'landlordPortal.editMaintenanceTicketForm.templateDetailsUpcase'
                    )}
                  </p>
                </div>
              </div>

              <div className="row" style={{ padding: '0 15px' }}>
                <RecurringFields formName={this.props.formName} />
              </div>
            </div>
          )}

          <div className="row" style={style.receipt_header}>
            <div className="col-xs-12">
              <p style={{ margin: '0', textAlign: 'center' }}>
                {getTranslatedString(
                  'landlordPortal.editMaintenanceTicketForm.ticketDetailsUpcase'
                )}
              </p>
            </div>
          </div>

          <div className="row" style={{ padding: '0 15px 15px' }}>
            <div className="col-sm-12">
              <Field
                name="subject"
                validate={[validator.required]}
                component={TextField}
                floatingLabelText={getTranslatedString(
                  'landlordPortal.editMaintenanceTicketForm.subject'
                )}
                fullWidth
                style={{ marginTop: '-15px', fontSize: '14px' }}
                disabled={readOnly}
              />
            </div>
            <div className="col-sm-12">
              <Field
                name="ticket_description"
                component={TextField}
                validate={[validator.required]}
                floatingLabelText={getTranslatedString(
                  'landlordPortal.editMaintenanceTicketForm.description'
                )}
                multiLine
                fullWidth
                rows={1}
                style={{ marginTop: '-15px', fontSize: '14px' }}
                disabled={readOnly}
              />
            </div>
            <div className="col-sm-6" style={{ marginTop: '-7px' }}>
              <Field
                name="status"
                component={SelectField}
                style={{ marginTop: '-9px', fontSize: '14px' }}
                floatingLabelText={getTranslatedString(
                  'landlordPortal.editMaintenanceTicketForm.status'
                )}
                fullWidth
                autoWidth
                validate={[validator.required]}
                disabled={readOnly}
              >
                {this.getMaintenanceStatuses().map((status) => (
                  <MenuItem
                    value={status.value}
                    primaryText={getTranslatedString(status.label)}
                    disabled={status.disabled}
                  />
                ))}
              </Field>
            </div>
            <div className="col-sm-6">
              <Field
                name="priority"
                component={SelectField}
                floatingLabelText={getTranslatedString(
                  'landlordPortal.editMaintenanceTicketForm.priority'
                )}
                fullWidth
                autoWidth
                validate={[validator.required]}
                style={{ marginTop: '-14px', fontSize: '14px' }}
                disabled={readOnly}
              >
                <MenuItem
                  value={'Emergency'}
                  primaryText={getTranslatedString(
                    'landlordPortal.editMaintenanceTicketForm.emergency'
                  )}
                />
                <MenuItem
                  value={'High'}
                  primaryText={getTranslatedString('landlordPortal.editMaintenanceTicketForm.high')}
                />
                <MenuItem
                  value={'Normal'}
                  primaryText={getTranslatedString(
                    'landlordPortal.editMaintenanceTicketForm.normal'
                  )}
                />
              </Field>
            </div>
            <div className="col-sm-12">
              <Field
                name="suite_location"
                component={SelectField}
                style={{ marginTop: '-14px', fontSize: '14px' }}
                floatingLabelText={getTranslatedString(
                  'landlordPortal.editMaintenanceTicketForm.location'
                )}
                fullWidth
                autoWidth
                validate={[validator.required]}
                iconStyle={{ marginLeft: '20px !important' }}
                disabled={readOnly}
              >
                {getSuiteRooms(this.props.isInSuite, this.getPropertyType()).map((room) => (
                  <MenuItem
                    value={room.value}
                    key={getTranslatedString(room.label)}
                    label={getTranslatedString(room.label)}
                  >
                    {getTranslatedString(room.label)}
                  </MenuItem>
                ))}
              </Field>
            </div>
            <div className="col-sm-12" style={{ marginTop: '14px' }}>
              <Field
                name="assign"
                component={SearchableSelectRedux}
                filter={(searchText, key) => key.indexOf(searchText) !== -1}
                fullWidth
                grouped
                options={this.props.maintenanceStaff}
                placeholder={getTranslatedString(
                  'landlordPortal.editMaintenanceTicketForm.assignTo'
                )}
                onChange={this.handleAssigneeChange}
                disabled={readOnly}
              />
            </div>
            <RenderIfToggleOn toggle="maintenance.vendor_statuses_and_notifications">
              {this.canRemindVendor() && (
                <RemindVenderButton
                  handleRemindVendor={this.remindVendor}
                  remindingVendor={this.props.remindingVendor}
                  isDirty={this.props.dirty}
                />
              )}
            </RenderIfToggleOn>

            {['Fixed', 'Closed'].includes(this.props.ticketStatus) && (
              <div className="col-sm-12" style={{ marginTop: '14px' }}>
                <Field
                  name="completion_date"
                  component={DatePickerAccessible}
                  fullWidth
                  showTimeSelect
                  dateMode="datetime"
                  formatDate={formatter.reformatDate}
                  label={getTranslatedString('landlordPortal.maintenance.completedOn')}
                  style={{ fontSize: '14px' }}
                  textFieldStyle={{ fontSize: '14px' }}
                  dateFormat="Pp"
                />
              </div>
            )}
          </div>

          {this._renderAdditionalInformation()}

          <RenderIfToggleOn toggle="maintenance.scheduling">
            <div className="row" style={style.receipt_header}>
              <div className="col-xs-12">
                <p style={{ margin: '0', textAlign: 'center' }}>
                  {getTranslatedString('landlordPortal.editMaintenanceTicketForm.schedulingUpcase')}
                </p>
              </div>
            </div>
            <div className="row" style={{ padding: '5px 15px 20px' }}>
              <div className="col-sm-12" style={{ marginBottom: '10px' }}>
                {!this.props.scheduled && readOnly ? (
                  <p style={{ margin: '0', textAlign: 'center' }}>
                    {getTranslatedString('landlordPortal.editMaintenanceTicketForm.notScheduled')}
                  </p>
                ) : (
                  <Field
                    name="scheduled"
                    component={Checkbox}
                    label={getTranslatedString('landlordPortal.editMaintenanceTicketForm.schedule')}
                    disabled={readOnly}
                  />
                )}
              </div>
              {this.renderScheduledFields(readOnly)}
            </div>
          </RenderIfToggleOn>

          <div className="row" style={style.receipt_header}>
            <div className="col-xs-12">
              <p style={{ margin: '0', textAlign: 'center' }}>
                {getTranslatedString('landlordPortal.editMaintenanceTicketForm.otherDetailsUpcase')}
              </p>
            </div>
          </div>
          <RenderIfToggleOn toggle="ui.create_service_request.consent_to_entry_while_away">
            <div className="row" style={{ padding: '0 15px' }}>
              <div className="col-sm-12">
                <Field
                  name="consent_to_entry_while_away"
                  component={SelectField}
                  floatingLabelText={getTranslatedString(
                    'landlordPortal.serviceRequest.consentToEntryWhileAway'
                  )}
                  fullWidth
                  autoWidth
                  validate={[validator.required]}
                  style={{ marginTop: '-14px', fontSize: '14px' }}
                  disabled={readOnly}
                >
                  <MenuItem
                    value={true}
                    key={0}
                    primaryText={getTranslatedString('request_type.yes')}
                  />
                  <MenuItem
                    value={false}
                    key={1}
                    primaryText={getTranslatedString('request_type.no')}
                  />
                </Field>
              </div>
            </div>
          </RenderIfToggleOn>
          <div className="row" style={{ padding: '0 15px', marginTop: '15px' }}>
            <RenderIfToggleOn toggle="maintenance.vendor_statuses_and_notifications">
              <div className="col-sm-12">
                <Field
                  name="complete_by"
                  component={DatePickerAccessible}
                  fullWidth
                  showTimeSelect
                  dateMode="datetime"
                  formatDate={formatter.reformatDate}
                  label={getTranslatedString(
                    'landlordPortal.editMaintenanceTicketForm.completedBy'
                  )}
                  style={{ fontSize: '14px' }}
                  textFieldStyle={{ fontSize: '14px' }}
                  dateFormat="Pp"
                />
              </div>
            </RenderIfToggleOn>
            <RenderIfToggleOn toggle="maintenance.scheduling">
              <div className="col-sm-6">
                <Field
                  name="scheduled_at"
                  component={DatePickerAccessible}
                  showYearDropdown
                  showMonthDropdown
                  peekNextMonth
                  formatDate={formatter.reformatDate}
                  label={getTranslatedString('landlordPortal.editMaintenanceTicketForm.entryDate')}
                  fullWidth
                  style={{ fontSize: '14px' }}
                  textFieldStyle={{ fontSize: '14px' }}
                  disabled={
                    readOnly || this.props.companyPreferences.enable_ticket_scheduling_customization
                  }
                />
              </div>
            </RenderIfToggleOn>
            <RenderIfToggleOn toggle="ui.create_service_request.permission_to_enter">
              <div className="col-sm-6">
                <Field
                  name="permission_to_enter"
                  component={SelectField}
                  floatingLabelText={getTranslatedString(
                    'landlordPortal.editMaintenanceTicketForm.entryPermission'
                  )}
                  fullWidth
                  autoWidth
                  validate={[validator.required]}
                  style={{ marginTop: '-14px', fontSize: '14px' }}
                  disabled={readOnly}
                >
                  <MenuItem
                    value={true}
                    primaryText={getTranslatedString(
                      'landlordPortal.editMaintenanceTicketForm.yes'
                    )}
                  />
                  <MenuItem
                    value={false}
                    primaryText={getTranslatedString('landlordPortal.editMaintenanceTicketForm.no')}
                  />
                </Field>
              </div>
            </RenderIfToggleOn>
          </div>
          <div className="row" style={{ padding: '0 15px' }}>
            <div className="col-sm-6">
              <Field
                name="category"
                component={SelectField}
                style={{ marginTop: '-15px', fontSize: '14px' }}
                floatingLabelText={getTranslatedString(
                  'landlordPortal.editMaintenanceTicketForm.category'
                )}
                fullWidth
                autoWidth
                validate={[validator.required]}
                disabled={readOnly}
              >
                {this.getMaintenanceTicketCategories().map((category) => (
                  <MenuItem value={category.value} key={category.label} label={category.label}>
                    {category.label}
                  </MenuItem>
                ))}
              </Field>
            </div>
            <div className="col-sm-6">
              <Field
                name="request_type"
                component={SelectField}
                style={{ marginTop: '-15px', fontSize: '14px' }}
                floatingLabelText={getTranslatedString(
                  'landlordPortal.editMaintenanceTicketForm.requestType'
                )}
                fullWidth
                autoWidth
                validate={[validator.required]}
                iconStyle={{ marginLeft: '20px !important' }}
                disabled={readOnly}
              >
                {requestDropdown.map((requestType) => {
                  return (
                    <MenuItem
                      value={requestType}
                      primaryText={getTranslatedString(
                        `landlordPortal.editMaintenanceTicketForm.${camelCase(requestType)}`
                      )}
                      disabled={[
                        'Preventative Maintenance',
                        'Portal Request - Maintenance',
                        'Portal Request - Other',
                        'Kiosk Request',
                      ].includes(requestType)}
                    />
                  );
                })}
              </Field>
            </div>
          </div>
          <div className="row" style={{ padding: '0 15px' }}>
            <div
              className="col-sm-6"
              id="subcat"
              style={{ marginTop: '10px', marginBottom: '15px' }}
            >
              <Field
                name="subcategory"
                component={Autosuggest}
                style={{ marginTop: '-9px', fontSize: '14px' }}
                label={getTranslatedString('landlordPortal.editMaintenanceTicketForm.subcategory')}
                suggestions={this.props.companyPreferences.maintenance_tags}
                fullWidth
                disabled={readOnly}
              />
            </div>
            <div className="col-sm-6">
              <Field
                name="classification"
                component={SelectField}
                floatingLabelText={getTranslatedString(
                  'landlordPortal.editMaintenanceTicketForm.classification'
                )}
                fullWidth
                autoWidth
                validate={[validator.required]}
                style={{ marginTop: '-14px', fontSize: '14px' }}
                disabled={readOnly}
              >
                <MenuItem
                  value="General Maintenance"
                  primaryText={getTranslatedString(
                    'landlordPortal.editMaintenanceTicketForm.generalMaintenance'
                  )}
                />
                <MenuItem
                  value="Capital Projects"
                  primaryText={getTranslatedString(
                    'landlordPortal.editMaintenanceTicketForm.capitalProjects'
                  )}
                />
                <MenuItem
                  value="Replacement"
                  primaryText={getTranslatedString(
                    'landlordPortal.editMaintenanceTicketForm.replacement'
                  )}
                />
              </Field>
            </div>
          </div>
          <div className="row" style={{ padding: '0 15px' }}>
            <div className="col-sm-12">
              <Field
                name="hide_from_tenant"
                component={SelectField}
                floatingLabelText={getTranslatedString('doNotDisplayToTenant')}
                fullWidth
                autoWidth
                validate={[validator.required]}
                style={{ fontSize: '14px' }}
                disabled={readOnly}
              >
                <MenuItem value={true} primaryText={getTranslatedString('request_type.yes')} />
                <MenuItem value={false} primaryText={getTranslatedString('request_type.no')} />
              </Field>
            </div>
          </div>
          <RenderIfToggleOn toggle="ui.maintenance.show_external_po_number_field">
            <div className="row" style={{ padding: '0 15px 10px' }}>
              <div className="col-sm-12" style={{ marginTop: '-10px' }}>
                <Field
                  name="external_po_number"
                  component={TextField}
                  floatingLabelText={getTranslatedString(
                    'landlordPortal.editMaintenanceTicketForm.externalPoNumber'
                  )}
                  fullWidth
                  style={{
                    fontSize: '14px',
                  }}
                  disabled={readOnly}
                />
              </div>
            </div>
          </RenderIfToggleOn>

          <div className="row" style={{ padding: '0 15px' }}>
            <div className="col-xs-12" style={{ marginTop: '-10px' }}>
              <Field
                name="internal_notes"
                component={TextField}
                floatingLabelText={getTranslatedString(
                  'landlordPortal.editMaintenanceTicketForm.internalNotes'
                )}
                hintText={
                  <span>
                    <TenantResidentVerbiageHelper capitalize />
                    {getTranslatedString(
                      'landlordPortal.editMaintenanceTicketForm.willNotSeeTheseNotes'
                    )}
                  </span>
                }
                hintStyle={{ fontSize: '13px' }}
                rows={3}
                multiLine
                fullWidth
                style={{
                  marginTop: '-15px',
                  fontSize: '14px',
                  marginBottom: '4px',
                }}
                disabled={readOnly}
              />
            </div>
          </div>
          <div className="row" style={{ padding: '0 15px' }}>
            <div className="col-xs-12" style={{ marginTop: '10px' }}>
              {!this.props.isTenantDamaged && readOnly ? (
                <p
                  style={{
                    margin: '0',
                    textAlign: 'center',
                    marginBottom: '10px',
                  }}
                >
                  {getTranslatedString('landlordPortal.editMaintenanceTicketForm.notTenantDamaged')}
                </p>
              ) : (
                <Field
                  name="is_tenant_damaged"
                  component={Checkbox}
                  label={getTranslatedString(
                    'landlordPortal.editMaintenanceTicketForm.tenantDamaged'
                  )}
                  disabled={readOnly}
                />
              )}
            </div>
          </div>

          <div className="row" style={style.receipt_header}>
            <div className="col-xs-12">
              <p style={{ margin: '0', textAlign: 'center' }}>
                {getTranslatedString('landlordPortal.editMaintenanceTicketForm.photoUpcase')}
              </p>
            </div>
          </div>

          <div className="row" style={{ padding: '0 30px', marginBottom: '10px' }}>
            <Field
              name={FILE_FIELD_NAME}
              component={RenderDropzoneMultiFileInput}
              uploadedFilesKey="photos"
              formName={this.props.formName}
              acceptedFileTypes="image/jpeg, image/png, image/jpg, application/pdf"
              useLightbox
              readOnly={readOnly}
            />
          </div>
          {this._renderTicketNotes()}
        </div>

        {this.props.vendorComments.length > 0 && (
          <div>
            <div className="row" style={style.receipt_header}>
              <div className="col-xs-12">
                <p style={{ margin: '0', textAlign: 'center' }}>
                  {getTranslatedString(
                    'landlordPortal.editMaintenanceTicketForm.vendorNotesUpcase'
                  )}
                </p>
              </div>
            </div>
            <div className="row" style={{ padding: '0 30px', marginBottom: '10px' }}>
              <NotesSection notes={this.props.vendorComments} />
            </div>
          </div>
        )}
      </form>
    );
  }

  _renderTenantDetailsIndustrial = () => {
    if (!this.props.initialValues.requested_by_full_name) return;

    return (
      <div className="row">
        <div className="col-xs-12">
          <h5
            style={{
              paddingBottom: '5px',
              margin: '0 0 5px',
              borderBottom: '2px solid ' + AccentColor(),
            }}
          >
            <TenantResidentVerbiageHelper capitalize />{' '}
            {getTranslatedString('landlordPortal.editMaintenanceTicketForm.details')}
          </h5>
          <div className="row">
            <p style={{ margin: '0 0 2px' }}>{this.props.initialValues.requested_by_full_name}</p>
            <p style={{ margin: '0 0 2px' }}>
              {getTranslatedString('landlordPortal.editMaintenanceTicketForm.deskNumber')}{' '}
              {this.props.initialValues.requested_by_desk_number}
            </p>
            <p style={{ margin: '0 0 2px' }}>
              {formatter.formatPhone(this.props.initialValues.requested_by_phone_number)}
            </p>
            <p style={{ margin: '0 0 2px' }}>{this.props.initialValues.requested_by_email}</p>
          </div>
        </div>
      </div>
    );
  };

  _renderTenantDetails = (readOnly) => {
    if (!this.props.initialValues.cotenants) return;
    if (this.props.initialValues.cotenants.length === 0) return;
    if (this.props.initialValues.requested_by_full_name) return;

    return (
      <div className="row">
        <div className="col-xs-12">
          <h5
            style={{
              paddingBottom: '5px',
              margin: '0 0 5px',
              borderBottom: '2px solid ' + AccentColor(),
            }}
          >
            <TenantResidentVerbiageHelper
              translatedTenant={getTranslatedString(
                'landlordPortal.editMaintenanceTicketForm.tenantDetails'
              )}
              translatedResident={getTranslatedString(
                'landlordPortal.editMaintenanceTicketForm.residentDetails'
              )}
            />{' '}
          </h5>
        </div>
        {this.props.initialValues.cotenants.map((lease_holder) => {
          if (readOnly) {
            return (
              <div key={lease_holder.id} className="col-xs-12">
                <p>{lease_holder.full_name}</p>
              </div>
            );
          }

          return (
            <div key={lease_holder.id} className="col-xs-12">
              <button
                type="button"
                className="link-button"
                onClick={() => this.openTenant(lease_holder.id)}
              >
                {lease_holder.full_name}
              </button>
            </div>
          );
        })}
      </div>
    );
  };

  _renderTicketNotes = () => {
    if (!this.props.initialValues.cotenants) return;
    if (this.props.initialValues.cotenants.length === 0) return;
    if (this.props.showRecurrance) return;
    if (hostIsBoardwalk()) return;
    if (this.readOnly()) return;

    return <TenantMaintenanceNotes ticketId={this.props.ticketId} />;
  };

  _renderAdditionalInformation = () => {
    if (!this.props.initialValues.tenant_note) return;

    return (
      <div className="row">
        <Header
          name={
            <span style={{ textTransform: 'uppercase !important' }}>
              <TenantResidentVerbiageHelper
                uppercase
                translatedTenant={getTranslatedString(
                  'landlordPortal.editMaintenanceTicketForm.tenantAdditionalInformationFromUpcase'
                )}
                translatedResident={getTranslatedString(
                  'landlordPortal.editMaintenanceTicketForm.residentAdditionalInformationFromUpcase'
                )}
              />
            </span>
          }
        />
        <p style={{ padding: '15px 30px', textAlign: 'justify', margin: 0 }}>
          {this.props.initialValues.tenant_note}
        </p>
      </div>
    );
  };

  renderScheduledFields = (readOnly) => {
    const durationOptions = this.props.companyPreferences.ticket_scheduling_durations;
    const startTimeOptions = this.props.companyPreferences.ticket_scheduling_starts_at_times;
    if (!this.props.scheduled) return null;
    return (
      <Fragment>
        <div className="row">
          <div className="col-sm-6">
            <Field
              name="scheduled_starts_at_date"
              component={DatePickerAccessible}
              formatDate={formatter.reformatDate}
              label={getTranslatedString('landlordPortal.editMaintenanceTicketForm.startDate')}
              fullWidth
              style={{ marginTop: '-19px', fontSize: '14px' }}
              textFieldStyle={{ fontSize: '14px' }}
              validate={[validator.required]}
              minDate={new Date()}
              disabled={readOnly}
            />
          </div>
          <div className="col-sm-6">
            <Field
              fullWidth
              name="scheduled_starts_at_time"
              component={SelectField}
              autoWidth
              floatingLabelText={getTranslatedString(
                'landlordPortal.editMaintenanceTicketForm.startTime'
              )}
              validate={[validator.required]}
              style={{ marginTop: '-19px', fontSize: '14px' }}
              textFieldStyle={{ fontSize: '14px' }}
              disabled={readOnly}
            >
              {startTimeOptions.map((option) => (
                <MenuItem key={`start_time_${option}`} value={option} primaryText={option} />
              ))}
            </Field>
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6">
            <Field
              fullWidth
              name="scheduled_duration"
              component={SelectField}
              autoWidth
              floatingLabelText={getTranslatedString(
                'landlordPortal.editMaintenanceTicketForm.duration'
              )}
              validate={[validator.required]}
              style={{ fontSize: '14px' }}
              textFieldStyle={{ fontSize: '14px' }}
              disabled={readOnly}
            >
              {durationOptions.map((option) => {
                return (
                  <MenuItem
                    key={`duration_${option}`}
                    value={option}
                    primaryText={`${option} ${getTranslatedString(
                      'landlordPortal.editMaintenanceTicketForm.hour'
                    )}`}
                  />
                );
              })}
            </Field>
          </div>
        </div>
      </Fragment>
    );
  };
};

const mapStateToProps = (store, ownProps) => {
  return {
    form: ownProps.formName,
    properties: store.landlordProperties.properties,
    maintenanceAssets: store.maintenanceReducer.maintenanceAssets,
    units: store.landlordProperties.units,
    unitActiveLease: store.landlordProperties.unitActiveLease,
    maintenanceStaff: store.maintenanceReducer.maintenance,
    scheduled: formValueSelector(ownProps.formName)(store, 'scheduled'),
    selectedUnit: formValueSelector(ownProps.formName)(store, 'unit'),
    isTenantDamaged: formValueSelector(ownProps.formName)(store, 'is_tenant_damaged'),
    isInSuite: !!deepDiver(store, 'maintenanceTicket.ticketDetails.unit_id'),
    selectedProperty: formValueSelector(ownProps.formName)(store, 'property'),
    maintenanceCategories: store.maintenanceReducer.maintenanceCategories,
    vendorComments: deepDiver(store, 'maintenanceTicket.ticketDetails.vendor_comments'),
    remindingVendor: store.maintenanceTicket.remindingVendor,
    ticketStatus: deepDiver(store, 'maintenanceTicket.ticketDetails.status'),
    assignedTo: deepDiver(store, 'maintenanceTicket.ticketDetails.assign'),
    assign: formValueSelector(ownProps.formName)(store, 'assign'),
    status: formValueSelector(ownProps.formName)(store, 'status'),
  };
};

export default compose(
  connect(mapStateToProps, {
    getUnits,
    getProperties,
    showUnits,
    getListOfMaintenanceStaff,
    getAssets,
    remindVendor,
    changeFormValue: change,
  }),
  reduxForm({
    destroyOnUnmount: true,
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })
)(EditMaintenanceTicketForm);

const RemindVenderButton = ({ handleRemindVendor, remindingVendor, isDirty }) => {
  const disable = remindingVendor || isDirty;
  return (
    <div className="col-sm-12" style={{ textAlign: 'center', marginTop: '30px' }}>
      <FlatButton
        label={getTranslatedString('landlordPortal.editMaintenanceTicketForm.remindVendor')}
        onClick={() => handleRemindVendor()}
        primary={true}
        backgroundColor={disable ? colors.LIGHT_GRAY : AccentColor()}
        disabled={disable}
        hoverColor="grey"
        style={{
          color: colors.WHITE,
          height: '40px',
        }}
      />
    </div>
  );
};
